module.exports = __webpack_public_path__ + "img/mei.f0d1bd65.png";